import { render } from "./ListeCategorieArticlePage.vue?vue&type=template&id=242cb7ef&ts=true"
import script from "./ListeCategorieArticlePage.vue?vue&type=script&lang=ts"
export * from "./ListeCategorieArticlePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__